/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

export enum ElementType {
  PIPE = 1,
  ELBOW,
  REDUCTION,
  TAP,
  FLATTENING,
  FLANGE,
  PUSH_COVER,
  RIBBED_COVER,
  DOUBLE_ELBOW = 11,
  FLANGE_CAP,
  VALVE_CAP,
  COFFER_VALVE_CAP,
  COFFER_CAP,
  OVAL_CAP_REGULAR,
  OVAL_CAP_UNREGULAR
};
